import { IBBoxSchema } from '../../../../node/types/bbox';
import { EFetchMapDataActionType } from '../../../common/actions/fetchMapData/types';
import { EMapBoundsActionType } from '../../../common/actions/mapBounds';
import { IApplicationState, TReduxActions } from '../../../common/types/redux';
import { bboxToMapBounds } from '../../../common/utils/mapBounds';
import { TMapBounds } from '../../types/mapBounds';

const initialState: IApplicationState['map']['mapBounds'] = {
  center: [0, 0],
  zoom: 0,
  precision: 0,
  bounds: [
    [0, 0],
    [0, 0],
  ],
};

export function mapBoundsReducer(
  state: IApplicationState['map']['mapBounds'] = initialState,
  action: TReduxActions,
): IApplicationState['map']['mapBounds'] {
  switch (action.type) {
    case EFetchMapDataActionType.Succeed: {
      if (!action.payload.updateBounds) {
        return state;
      }

      /**
       * Остальные значения будут получены при следующей перерисовке
       * @see {@link MapBoundsUpdater}
       */
      return bboxToMapBounds(action.payload.bbox as IBBoxSchema) as TMapBounds;
    }

    case EMapBoundsActionType.Changed:
      return action.payload;

    /**
     * Фокус на области гео (applyGeoChange): как и Succeed+updateBounds, кладёт только
     * bounds/center — остальные значения дозаполнит boundschange после setBounds.
     */
    case EMapBoundsActionType.FocusedOnBbox:
      return bboxToMapBounds(action.payload) as TMapBounds;
  }

  return state;
}
